<template>
    <div class="page-wrapper bg-white radius-lg padding margin-left-sm">
        <div class="search-container min flex align-center">
            <div class="flex align-center">
                <el-autocomplete class="input" v-model="client" placeholder="请输入委托单位"
                                 :fetch-suggestions="queryClientsSearch"  value-key="company_name"
                                 @select="handleClientsSelect"></el-autocomplete>
                <el-autocomplete class="input margin-left-xs" v-model="undertaker" placeholder="请输入承办单位"
                                 :fetch-suggestions="queryUndertakerSearch" value-key="company_name"
                                 @select="handleUndertakerSelect"></el-autocomplete>
                <el-select class="margin-left-xs" v-model="p_mid" filterable clearable placeholder="请选择负责人">
                    <el-option
                        v-for="item in members"
                        :key="item.mid"
                        :label="item.name"
                        :value="item.mid">
                    </el-option>
                </el-select>
                <el-input class="margin-left-xs" v-model="keyword" placeholder="请输入项目名称"></el-input>
                <el-button class="search-submit" type="primary" @click="search">搜索</el-button>
            </div>
        </div>
        <div class="page-list flex flex-direction margin-top-sm">
            <el-table
                v-loading="loading"
                :data="lists"
                border
                header-row-class-name="table-header"
                style="width: 100%">
                <el-table-column label="年度" prop="create_time" width="80">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.create_time | year }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="项目名称" prop="p_name">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.p_name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="委托单位" prop="client">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.client || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="承办单位" prop="undertaker">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.undertaker || '--'  }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="负责人" prop="p_mid" width="120">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.fuzeren_name || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="项目进度" prop="name" width="279">
                    <template slot-scope="scope">
                        <div class="table-item" v-if="scope.row.is_declare && scope.row.state !== 4">
                            <div :class="scope.row.state | astatus_color">{{ scope.row.state | astatus }}</div>
                        </div>
                        <div class="table-item" v-else>
                            <div v-if="scope.row.check_status === 0">
                                <div class="flex flex-direction" v-if="scope.row.status === 2">
                                    <div class="flex align-center">
                                        <div class="flex-shrink text-black text-xs">执行进度</div>
                                        <el-progress class="flex-sub margin-left-xs flex align-center"  :stroke-width="10" :color="customColors" :percentage="scope.row.taskLv"></el-progress>
                                    </div>
                                    <div class="flex align-center">
                                        <div class="flex-shrink text-black text-xs">时间进度</div>
                                        <el-progress class="flex-sub margin-left-xs flex align-center"  :stroke-width="10" :percentage="scope.row.timeLv"></el-progress>
                                    </div>
                                </div>
                                <div :class="scope.row.status | pstatus_color" v-else>{{ scope.row.status | pstatus }}</div>
                            </div>
                            <div v-else>{{ scope.row.check_status | cstatus }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" prop="name" width="310">
                    <template slot-scope="scope">
                        <!-- 申报项目 且未完成申报 -->
                        <div class="table-operate flex flex-direction"  v-if="scope.row.is_declare && scope.row.state !== 4">
                            <div class="flex align-center">
                                <el-button class="radius" style="width: 90px" type="primary" size="small" @click="toPage(`/web/principal/apply/review/${scope.row.id}`)">申报信息</el-button>
                            </div>
                        </div>
                        <div class="table-operate flex flex-direction align-center" v-else>
                            <div class="flex align-center">
                                <el-button class="radius" style="width: 90px" type="primary" size="small" @click="toPage(`/web/principal/project/add/${scope.row.id}/0`)">项目信息</el-button>
                                <el-button class="radius" style="width: 190px" type="primary" size="small" @click="toPage(`/web/principal/task/assignment/apply/${scope.row.id}/${scope.row.p_name}`)" :disabled="scope.row.status === 0">分配及权重赋分审核</el-button>
                            </div>
                            <div class="flex align-center" v-if="scope.row.status === 2">
                                <el-button class="radius margin-top-xs" style="width: 90px" type="primary" size="small" @click="toPage(`/web/principal/task/apply/${scope.row.id}/${scope.row.p_name}`)">修改审核
                                    <el-badge class="text-orange" is-dot v-if="scope.row.xiugai_num">{{scope.row.xiugai_num}}</el-badge>
                                </el-button>
                                <el-button class="radius margin-top-xs" style="width: 90px" type="primary" size="small" @click="toPage(`/web/principal/task/review/${scope.row.id}/${scope.row.p_name}`)">完成评审
                                    <el-badge class="text-orange" is-dot v-if="scope.row.pingshen_num">{{scope.row.pingshen_num}}</el-badge>
                                </el-button>
                                <el-button class="radius margin-top-xs" style="width: 90px" type="primary" size="small" @click="toPage(`/web/principal/project/report/${scope.row.id}/${scope.row.p_name}`)">项目汇报</el-button>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="开始时间" prop="end_time" width="120">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.start_time || '--'  }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="计划结束时间" prop="end_time" width="120">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.end_time || '--'  }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all margin-top self-end"
                layout="prev, pager, next"
                @current-change="init">
            </el-pagination>
        </div>
    </div>
</template>

<script>

import {getAllMember, getCompanyList, getProjectExList} from "@/api";
import {filterDate, zhDate} from "@/utils/utils";
import {apply_status, apply_status_color, customColors} from "@/utils/const";

export default {
    name: "project-list",
    components: {},
    data() {
        return {
            customColors:customColors,
            keyword:'',
            client:'',
            undertaker:'',
            p_mid:'',
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            loading: false,
            clients:[],
            undertakers:[],
            members:[]
        }
    },
    created() {
        this.$emit('setIndex', [1,3], '项目审核', false)
        this.getClassify()
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async getClassify() {
            let _data = await getAllMember()
            this.members = _data.data
            _data = await getCompanyList(1,'',1,1000)
            this.clients = _data.data.data
            _data = await getCompanyList(2,'',1,1000)
            this.undertakers = _data.data.data
        },
        async init() {
            this.loading = true
            let _data = await getProjectExList(this.keyword,this.client,this.undertaker,this.p_mid,this.page,this.limit)
            this.loading = false
            _data.data.data.map(item=>{
                item.start_time = filterDate(item.start_time)
                item.end_time = filterDate(item.end_time)
            })
            this.lists = _data.data.data
            this.total = _data.data.total
        },
        search() {
            this.page = 1
            this.init()
        },
        toPage(path) {
            this.$router.push(path)
        },
        queryClientsSearch(queryString, cb) {
            let restaurants = this.clients;
            let results = queryString ? restaurants.filter(this.createClientsFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createClientsFilter(queryString) {
            return (restaurant) => {
                return (restaurant.company_name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleClientsSelect(item) {
            this.client =  item.company_name
        } ,
        queryUndertakerSearch(queryString, cb) {
            let restaurants = this.undertakers
            let results = queryString ? restaurants.filter(this.createUndertakerFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createUndertakerFilter(queryString) {
            return (restaurant) => {
                return (restaurant.company_name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleUndertakerSelect(item) {
            this.undertaker = item.company_name
        }
    },
    filters:{
        year(date){
            return zhDate(date,4)
        },
        astatus(status){
            // //0 1提交审核 2通过 -2拒绝 3提交审核 4通过-4拒绝
            // /   /   /  /
            return apply_status(status)
        },
        astatus_color(status){
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            return apply_status_color(status)
        },
        pstatus(status){
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            switch (Number(status)) {
                case 0 : return '未提交审核'
                case 1 : return '未审核'
                case 2 : return '进行中'
                case 3 : return '已拒绝'
            }
        },
        pstatus_color(status){
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            switch (Number(status)) {
                case 0 : return 'text-black'
                case 1 : return 'text-orange'
                case 3 : return 'text-red'
            }
        },
        cstatus(check_status){
            //验收状态 1正常验收 2非正常验收
            switch (Number(check_status)) {
                case 0 : return '未结项'
                case 1 : return '正常结项'
                case 2 : return '非正常结项'
            }
        }
    },

}
</script>

<style lang="scss" scoped>
.page-wrapper {
}
</style>
